import { useState, useEffect, useCallback } from "react";
import * as notificationService from "../services/notificationService";

export const useNotifications = () => {
  const [state, setState] = useState(() => ({
    notifications: notificationService.getNotifications(),
    unreadCount: notificationService.getUnreadCount(),
    isLoading: notificationService.getIsLoading(),
  }));

  useEffect(() => {
    const unsubscribe = notificationService.subscribe((newState) => {
      setState(newState);
    });
    return () => {
      unsubscribe();
    };
  }, []);

  const markAsSeen = useCallback(async (notificationId) => {
    return notificationService.markAsSeen(notificationId);
  }, []);

  const markAllAsRead = useCallback(async () => {
    return notificationService.markAllAsSeen();
  }, []);

  const refreshNotifications = useCallback(async (options) => {
    return notificationService.fetchNotifications(options);
  }, []);

  const dismissAllToasts = useCallback(() => {
    notificationService.dismissAllToasts();
  }, []);

  return {
    notifications: state.notifications,
    unreadCount: state.unreadCount,
    isLoading: state.isLoading,
    markAsSeen,
    markAllAsRead,
    refreshNotifications,
    dismissAllToasts,
  };
};

export default useNotifications;
